import React from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import TablePagination from "../../shared/components/tables/TablePagination";

const UIKit = () => {
  const [value, setValue] = React.useState('10');
  const [open, setOpen] = React.useState(false);

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value as string);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  function createData(
    name: string,
    calories: number,
    fat: number,
    carbs: number,
    protein: number,
  ) {
    return { name, calories, fat, carbs, protein };
  }

  const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
  ];

  return (
    <>
      <div className="p-4">
        <div>
          <p className="heading-1">Buttons</p>

          <div className="flex gap-10">
            <div className="flex flex-col gap-5">
              <p className="heading-2">Inactive, Hover/Active</p>

              <Button variant="contained" aria-selected>Primary</Button>
              <Button variant="outlined">Secondary</Button>
              <Button variant="text">Tertiary</Button>
            </div>

            <div className="flex flex-col gap-5">
              <p className="heading-2">Disabled</p>

              <Button variant="contained" disabled>Primary</Button>
              <Button variant="outlined" disabled>Secondary</Button>
              <Button variant="text" disabled>Tertiary</Button>
            </div>
          </div>
        </div>

        <div className="mt-2">
          <p className="heading-1">Notifications</p>

          <div className="flex content-center mt-2">
            <Alert
              className="flex items-center"
              severity="success"
              variant="filled"
              onClose={() => { }}
            >
              This is a success Alert inside a Snackbar!
            </Alert>

            <Alert
              className="flex items-center"
              severity="error"
              variant="filled"
              onClose={() => { }}
            >
              This is error Alert inside a Snackbar!
            </Alert>

            <Alert
              className="flex items-center"
              severity="info"
              variant="filled"
              onClose={() => { }}
            >
              This is info Alert inside a Snackbar!
            </Alert>
          </div>
        </div>

        <div className="mt-2">
          <p className="heading-1">Inputs</p>

          <div>
            <InputLabel>Title</InputLabel>
            <TextField></TextField>
          </div>

          <div className="mt-2">
            <InputLabel>Title</InputLabel>
            <Select
              id="demo-simple-select"
              displayEmpty
              value={value}
              onChange={handleChange}
            >
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </div>
        </div>

        <div className="mt-2">
          <p className="heading-1">Dialog</p>

          <div className="mt-2">
            <Button variant="outlined" onClick={handleClickOpen}>
              Open dialog
            </Button>
          </div>

          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
              Dialog title
            </DialogTitle>

            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 14,
                top: 14,
                color: '#333333',
              }}
            >
              <CloseIcon />
            </IconButton>

            <DialogContent>
              <DialogContentText>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Vel minima facilis, nisi quaerat assumenda totam repellendus, repudiandae cum accusantium dolores porro minus eveniet, provident dolorem? Suscipit maxime ea incidunt fugiat.
                Magni id voluptatum consequuntur nulla nam iusto maxime ratione quis ipsa asperiores quod corrupti dolor eveniet inventore laboriosam facilis praesentium eum perferendis, beatae iure, impedit aliquam enim! A, officia maiores.
              </DialogContentText>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleClose} variant="contained" className="w-100">Disagree</Button>
            </DialogActions>
          </Dialog>
        </div>

        <div className="mt-2">
          <p className="heading-1">Table</p>

          <TableContainer component={Paper} className="mt-2">
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Dessert (100g serving)</TableCell>
                  <TableCell align="right">Calories</TableCell>
                  <TableCell align="right">Fat&nbsp;(g)</TableCell>
                  <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                  <TableCell align="right">Protein&nbsp;(g)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.calories}</TableCell>
                    <TableCell align="right">{row.fat}</TableCell>
                    <TableCell align="right">{row.carbs}</TableCell>
                    <TableCell align="right">{row.protein}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>


        <div>
          <p className="heading-1">Pagination</p>

          <TablePagination
            pageNo={2}
            pageSize={10}
            totalCount={30} />
        </div>
      </div>
    </>
  )
}

export default UIKit;